<script setup>
import { onMounted, ref, watch } from 'vue'
import CategorySearchSelect from '@/Components/Inputs/CategorySearchSelect.vue'

const props = defineProps({
  label: {
    type: String,
    required: false,
  },
  placeholder: {
    type: String,
    required: false,
    default: 'Search...',
  },
  selected: {
    type: Object,
    required: false,
    default: null,
  },
  primaryKey: {
    type: String,
    required: false,
    default: 'id',
  },
  labelKey: {
    type: String,
    required: false,
    default: 'name',
  },
  labelDescription: {
    type: String,
    required: false,
    default: 'breadcrumb',
  },
})

const emits = defineEmits(['filter'])

const selectedItem = ref(null)

onMounted(() => {
  if (props.selected) {
    selectedItem.value = props.selected
  }
})

watch(selectedItem, (value) => {
  emits('filter', value.id)
})

</script>

<template>
  <CategorySearchSelect v-bind="$props" v-model="selectedItem" />
</template>
